<template>
  <div class="switch-button">
    <div class="label-switch left">{{ labels.false }}</div>
    <label class="switch">
      <input v-model="checked" type="checkbox" :disabled="disabled" @change="$emit('update:status', checked)">
      <span class="slider" />
    </label>
    <div class="label-switch right">{{ labels.true }}</div>
  </div>
</template>

<script>
export default {
  name: 'ComponentSwitchButton',

  props: {
    status: {
      type: Boolean,
      required: false
    },
    labels: {
      type: Object,
      // Object or array defaults must be returned from
      // a factory function
      required: true,
      default() {
        return { true: null, false: null }
      }
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      checked: false
    }
  },

  created() {
    this.checked = this.status
  }
}
</script>

<style lang="scss" scoped>
  .switch-button {
    display: flex;
    align-items: center;

    // The switch - the box around the slider
    .switch {
      display: inline-block;
      position: relative;
      width: 36px;
      height: 20px;
      margin: 0 6px;

      // Hide default HTML checkbox
      input {
        width: 0;
        height: 0;
        opacity: 0;
      }

      // The slider
      .slider {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transition: .4s;
        background-color: $colour-secondary;
        cursor: pointer;

        &:before {
          content: "";
          position: absolute;
          bottom: 3px;
          left: 3px;
          width: 14px;
          height: 14px;
          transition: 400ms;
          background-color: white;
        }

        // Rounded sliders
        &.round {
          border-radius: 17px;

          &:before {
            border-radius: 50%;
          }
        }
      }

      input:checked + .slider {
        background-color: $colour-primary;
      }

      // input:focus + .slider {
      //   box-shadow: 0 0 1px $colour-primary;
      // }

      input:checked + .slider:before {
        transform: translateX(16px);
      }
    }

    .label-switch {
      font-size: 12px;
    }
  }
</style>
